import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoMapPinSelected = t0 => {
  const $ = _c(4);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M14.640 0.460 C 12.349 0.822,9.402 2.124,7.290 3.706 C 5.580 4.987,4.057 6.589,2.958 8.259 C 1.699 10.172,0.477 13.369,0.175 15.540 C 0.070 16.286,0.068 19.470,0.171 20.370 C 0.510 23.347,2.227 27.537,4.607 31.200 C 6.514 34.134,10.186 38.776,15.893 45.465 C 16.815 46.546,17.661 47.536,17.773 47.665 L 17.978 47.900 18.613 47.185 C 20.114 45.493,25.002 39.657,26.697 37.530 C 30.556 32.689,32.870 29.126,34.195 25.980 C 34.618 24.976,35.163 23.327,35.425 22.257 C 35.802 20.724,35.835 20.376,35.843 17.910 C 35.851 15.488,35.849 15.476,35.452 13.890 C 34.844 11.469,33.661 8.933,32.414 7.380 C 31.480 6.217,29.587 4.347,28.586 3.597 C 26.705 2.189,23.265 0.685,21.463 0.485 C 20.925 0.425,14.999 0.403,14.640 0.460" fill="#4A24DB" stroke="none" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== ariaLabel || $[2] !== className) {
    t2 = <svg width={36} height={48} viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}</svg>;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default IcoMapPinSelected;